import { normalizeQuotesInText, textHasTypographicQuotes } from "./quoteNormalize";

const TYPED_INPUT_TYPES = new Set(["insertText", "insertReplacementText"]);

let installCount = 0;

function onBeforeInput(event: Event): void {
  if (!(event instanceof InputEvent)) return;
  if (!TYPED_INPUT_TYPES.has(event.inputType)) return;
  const target = event.target;
  if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;
  const data = event.data;
  if (!data || !textHasTypographicQuotes(data)) return;
  event.preventDefault();
  const start = target.selectionStart ?? target.value.length;
  const end = target.selectionEnd ?? start;
  const replacement = normalizeQuotesInText(data);
  target.setRangeText(replacement, start, end, "end");
  target.dispatchEvent(
    new InputEvent("input", { bubbles: true, data: replacement, inputType: "insertText" })
  );
}

/**
 * Convert macOS/Safari smart quotes to straight quotes at the document level
 * (manuscript, titles, chat, and other fields).
 */
export function installStraightQuotes(): () => void {
  if (typeof document === "undefined") return () => {};
  if (installCount === 0) {
    document.addEventListener("beforeinput", onBeforeInput, true);
  }
  installCount += 1;
  return () => {
    installCount = Math.max(0, installCount - 1);
    if (installCount === 0) {
      document.removeEventListener("beforeinput", onBeforeInput, true);
    }
  };
}
